export enum Layout {
  Mobile = 'mobile',
  Desktop = 'desktop',
}

export enum Mode {
  Cost = 'cost',
  Frequency = 'frequency',
}
